module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1301.80f965d8.png";